export default __webpack_public_path__ + "d85b301adf5613f004103c57c1e3bd79.ico";